module.exports = __webpack_public_path__ + "static/nectar-mobile-23785833fa4b7a1b345acddccca7a525.jpg";